import React, { useEffect, useMemo, useState } from 'react';
import { sgsstInspecciones, getSgsstEmpleados } from '../services/api';
import SgsstTabs from '../components/SgsstTabs';
import { S, F, Grid, Grid3, Modal, useFlash, fdate, dateVal } from '../components/sgsstUi';

const CLASE = { locativa: 'Locativa', epp: 'EPP', extintores: 'Extintores', botiquin: 'Botiquín', orden_aseo: 'Orden y aseo', maquinaria: 'Maquinaria', electrica: 'Eléctrica', otra: 'Otra' };
const hoy = () => new Date().toISOString().slice(0, 10);
const VACIO = { tipo: 'planeada', clase: 'locativa', fecha: hoy(), area: '', responsable_id: '', responsable_nombre: '', observaciones: '', estado: 'realizada', items: [] };

function cumpl(items) { const ev = items.filter(i => i.cumple === 'si' || i.cumple === 'no'); if (!ev.length) return 0; return +(100 * ev.filter(i => i.cumple === 'si').length / ev.length).toFixed(1); }

export default function SgsstInspecciones() {
  const [lista, setLista] = useState([]);
  const [emp, setEmp] = useState([]);
  const [m, setM] = useState(null);
  const [msgNode, flash] = useFlash();
  const [busy, setBusy] = useState(false);

  const load = () => sgsstInspecciones.list().then(r => setLista(r.data)).catch(() => {});
  useEffect(() => { load(); getSgsstEmpleados().then(r => setEmp(r.data)).catch(() => {}); }, []);

  const abrirEditar = async (x) => { try { const { data } = await sgsstInspecciones.get(x.id); setM({ id: x.id, form: { ...VACIO, ...data, fecha: dateVal(data.fecha), items: data.items || [] } }); } catch (e) { flash(false, 'No se pudo abrir'); } };

  const addItem = () => { m.form.items.push({ descripcion: '', cumple: 'na', observacion: '' }); setM({ ...m }); };
  const setItem = (i, k, v) => { m.form.items[i][k] = v; setM({ ...m }); };
  const delItem = (i) => { m.form.items.splice(i, 1); setM({ ...m }); };

  const guardar = async () => {
    if (!m.form.fecha) return flash(false, 'La fecha es requerida');
    setBusy(true);
    try { if (m.id) await sgsstInspecciones.update(m.id, m.form); else await sgsstInspecciones.create(m.form); setM(null); load(); flash(true, '✅ Guardado'); }
    catch (e) { flash(false, '❌ ' + (e.response?.data?.error || 'No se pudo')); } finally { setBusy(false); }
  };
  const borrar = async (x) => { if (!window.confirm('¿Eliminar la inspección?')) return; try { await sgsstInspecciones.remove(x.id); load(); } catch (e) {} };

  const c = m ? cumpl(m.form.items) : 0;

  return (
    <div style={S.wrap}>
      <SgsstTabs />
      <div style={S.head}>
        <div><h1 style={S.h1}>Inspecciones de seguridad</h1><p style={S.sub}>Planeadas y no planeadas, con checklist y hallazgos.</p></div>
        <button style={S.btn} onClick={() => setM({ form: { ...VACIO, items: [] } })}>+ Nueva inspección</button>
      </div>
      {msgNode}
      <div style={S.card}><div style={{ overflowX: 'auto' }}>
        <table style={S.table}>
          <thead><tr>{['#', 'Fecha', 'Tipo', 'Clase', 'Área', 'Cumplimiento', 'Hallazgos', ''].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
          <tbody>
            {lista.length === 0 && <tr><td colSpan={8} style={S.empty}>Sin inspecciones.</td></tr>}
            {lista.map(x => (
              <tr key={x.id}>
                <td style={{ ...S.td, fontFamily: 'ui-monospace' }}>{x.consecutivo}</td>
                <td style={S.td}>{fdate(x.fecha)}</td>
                <td style={S.td}>{x.tipo === 'no_planeada' ? 'No planeada' : 'Planeada'}</td>
                <td style={S.td}>{CLASE[x.clase] || x.clase}</td>
                <td style={S.td}>{x.area || '—'}</td>
                <td style={{ ...S.td, fontWeight: 700, color: x.cumplimiento >= 90 ? '#10b981' : x.cumplimiento >= 70 ? '#f59e0b' : '#ef4444' }}>{x.cumplimiento}%</td>
                <td style={{ ...S.td, textAlign: 'center', color: x.hallazgos ? '#ef4444' : '#94a3b8' }}>{x.hallazgos || 0}</td>
                <td style={S.td}><button style={S.link} onClick={() => abrirEditar(x)}>Abrir</button><button style={{ ...S.link, color: '#fca5a5' }} onClick={() => borrar(x)}>Eliminar</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div></div>

      {m && <Modal title={m.id ? `Inspección #${m.form.consecutivo || ''}` : 'Nueva inspección'} onClose={() => setM(null)} wide>
        <Grid3>
          <F l="Tipo"><select style={S.in} value={m.form.tipo} onChange={e => setM({ ...m, form: { ...m.form, tipo: e.target.value } })}><option value="planeada">Planeada</option><option value="no_planeada">No planeada</option></select></F>
          <F l="Clase"><select style={S.in} value={m.form.clase} onChange={e => setM({ ...m, form: { ...m.form, clase: e.target.value } })}>{Object.entries(CLASE).map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></F>
          <F l="Fecha"><input type="date" style={S.in} value={m.form.fecha} onChange={e => setM({ ...m, form: { ...m.form, fecha: e.target.value } })} /></F>
        </Grid3>
        <Grid>
          <F l="Área / lugar"><input style={S.in} value={m.form.area} onChange={e => setM({ ...m, form: { ...m.form, area: e.target.value } })} /></F>
          <F l="Responsable">
            <select style={S.in} value={m.form.responsable_id || ''} onChange={e => { const emp2 = emp.find(x => x.id === e.target.value); setM({ ...m, form: { ...m.form, responsable_id: e.target.value, responsable_nombre: emp2 ? emp2.nombre : '' } }); }}>
              <option value="">— Sin asignar —</option>
              {emp.map(e => <option key={e.id} value={e.id}>{e.nombre}</option>)}
            </select>
          </F>
        </Grid>

        <div style={S.sec}>Checklist · cumplimiento {c}%</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 8 }}>
          {m.form.items.length === 0 && <div style={{ color: '#64748b', fontSize: 13 }}>Sin ítems. Agrega los puntos a verificar.</div>}
          {m.form.items.map((it, i) => (
            <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'center', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '7px 10px' }}>
              <input placeholder="Punto a verificar" style={{ ...S.in, flex: 1 }} value={it.descripcion} onChange={e => setItem(i, 'descripcion', e.target.value)} />
              <select style={{ ...S.in, width: 78 }} value={it.cumple} onChange={e => setItem(i, 'cumple', e.target.value)}>
                <option value="na">N/A</option><option value="si">Sí</option><option value="no">No</option>
              </select>
              <input placeholder="Observación" style={{ ...S.in, flex: 1 }} value={it.observacion || ''} onChange={e => setItem(i, 'observacion', e.target.value)} />
              <button style={{ ...S.link, color: '#fca5a5', margin: 0 }} onClick={() => delItem(i)}>✕</button>
            </div>
          ))}
        </div>
        <button style={S.btnSm} onClick={addItem}>+ Agregar ítem</button>
        <div style={{ ...S.sec, marginTop: 16 }}>Cierre</div>
        <F l="Observaciones generales"><textarea style={S.ta} value={m.form.observaciones} onChange={e => setM({ ...m, form: { ...m.form, observaciones: e.target.value } })} /></F>
        <F l="Estado"><select style={{ ...S.in, maxWidth: 220 }} value={m.form.estado} onChange={e => setM({ ...m, form: { ...m.form, estado: e.target.value } })}>{['programada', 'realizada', 'cerrada'].map(o => <option key={o} value={o}>{o}</option>)}</select></F>
        <div style={{ ...S.sec, border: 'none', fontSize: 11, color: '#64748b', fontWeight: 400, textTransform: 'none', letterSpacing: 0, margin: '4px 0 0' }}>Los ítems marcados "No" se registran como hallazgos.</div>
        <div style={S.modalBtns}><button style={S.btnGhost} onClick={() => setM(null)}>Cancelar</button><button style={S.btn} disabled={busy} onClick={guardar}>{busy ? 'Guardando…' : 'Guardar'}</button></div>
      </Modal>}
    </div>
  );
}
